import _regeneratorRuntime from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "vant/es/toast/style/less";
import _Toast from "vant/es/toast";
import "vant/es/dialog/style/less";
import _Dialog from "vant/es/dialog";
import _objectSpread from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import router from '@/router';
import auth from '@/utils/auth';
import store from '@/store';
import { appInfo, initIframeToLink } from '@/utils/utils';
import App from '@/utils/app'; // 弹窗配置

var realNameDialogOption = {
  title: '',
  message: '应国家法律法规与平台要求，请进行实名认证！',
  confirmButtonText: '去认证',
  cancelButtonText: '暂不认证',
  closeOnClickOverlay: true
};
var realNameFailDialogOption = {
  title: '',
  message: "\u60A8\u7684\u5B9E\u540D\u8BA4\u8BC1\u672A\u901A\u8FC7\uFF0C\u8BF7\u91CD\u65B0\u8BA4\u8BC1\uFF1B\u88AB\u62D2\u539F\u56E0\uFF1A\u8BA4\u8BC1\u5931\u8D25",
  confirmButtonText: '重新认证',
  cancelButtonText: '暂不认证',
  closeOnClickOverlay: true
};
var realNamePendingMsg = '实名认证在审核中，请耐心等待~';
var walletStatusDialogOption = {
  title: '',
  message: '你尚未开通富友钱包，无法操作，请先开通钱包！',
  confirmButtonText: '开通钱包',
  cancelButtonText: '暂不开通',
  closeOnClickOverlay: true
};
var walletDisabledMsg = '钱包已禁用，无法使用！';
var realNameLottieDialog = {
  title: '',
  message: '您尚未完成实名认证，无法抽奖！',
  confirmButtonText: '实名认证',
  cancelButtonText: '暂不认证',
  closeOnClickOverlay: true
}; // 进化dialog配置

var realNameEvolutionDialog = _objectSpread(_objectSpread({}, realNameDialogOption), {}, {
  className: 'dialog_light_class',
  overlayClass: 'overlay_dialog_light_class'
});

var realNameEvolutionFailDialog = _objectSpread(_objectSpread({}, realNameFailDialogOption), {}, {
  className: 'dialog_light_class',
  overlayClass: 'overlay_dialog_light_class'
}); // 小星球dialog设置


var realNameTPGameDialog = _objectSpread(_objectSpread({}, realNameDialogOption), {}, {
  className: 'dialog_light_class',
  overlayClass: 'overlay_dialog_light_class'
});

var realNameTPGameFailDialog = _objectSpread(_objectSpread({}, realNameFailDialogOption), {}, {
  className: 'dialog_light_class',
  overlayClass: 'overlay_dialog_light_class'
}); // 验证登录状态


export var validLogin = function validLogin(routePush) {
  return new Promise(function (resolve, reject) {
    if (appInfo) {
      // 如果app内打开
      store.dispatch('user/GetAppLogin').then(function () {
        resolve(true);
      }).catch(function () {
        // 未登录
        App.jumpLogin();
        reject(false);
      });
    } else {
      var token = auth.getToken() || ''; // 未登录

      if (!token) {
        if (routePush) {
          var _window$location = window.location,
              _window$location$path = _window$location.pathname,
              pathname = _window$location$path === void 0 ? '' : _window$location$path,
              _window$location$sear = _window$location.search,
              search = _window$location$sear === void 0 ? '' : _window$location$sear;
          routePush("/login?redirect=".concat(pathname).concat(window.encodeURIComponent(search)));
        } else {
          router.push({
            name: 'Login'
          });
        }

        reject(false);
      }

      resolve(true);
    }
  });
}; // 验证实名状态

export var validRealName = function validRealName(val) {
  return new Promise(function (resolve, reject) {
    var userInfo = auth.lsGetUserInfo() || {};
    var realNameInfo = auth.lsGetRealNameInfo() || {}; // const DialogOption = val === 'Lottie' ? realNameLottieDialog : realNameDialogOption
    // 根据类型使用不同的dialog option

    var DialogOption;
    var FailDialogOption;

    switch (val) {
      case 'Lottie':
        DialogOption = realNameLottieDialog;
        FailDialogOption = realNameFailDialogOption;
        break;

      case 'evolution':
        // 进化dialog
        DialogOption = realNameEvolutionDialog;
        FailDialogOption = realNameEvolutionFailDialog;
        break;

      case 'TPGame':
        // 小星球
        DialogOption = realNameTPGameDialog;
        FailDialogOption = realNameTPGameFailDialog;
        break;

      default:
        DialogOption = realNameDialogOption;
        FailDialogOption = realNameFailDialogOption;
    }

    var sceneMap = {
      Lottie: 'game',
      realNameExchangeRight: 'exchangeRight'
    };
    var scene = sceneMap[val] || '';

    if (userInfo.realNameAuth || realNameInfo.status === 's') {
      resolve(true);
    } // 实名失败


    if (!userInfo.realNameAuth && realNameInfo.status === 'f') {
      _Dialog.confirm(_objectSpread(_objectSpread({}, FailDialogOption), {}, {
        message: "\u60A8\u7684\u5B9E\u540D\u8BA4\u8BC1\u672A\u901A\u8FC7\uFF0C\u8BF7\u91CD\u65B0\u8BA4\u8BC1\uFF1B\u88AB\u62D2\u539F\u56E0\uFF1A".concat(realNameInfo.refuseReason || '-')
      })).then(function () {
        // 如果app内打开未实名
        if (appInfo) {
          App.jumpRzPage();
        } else {
          router.push({
            name: 'FYPersonalAuth',
            query: {
              scene: scene
            }
          });
        }
      }).catch(function () {});

      reject(false);
      return;
    } // 实名中


    if (!userInfo.realNameAuth && realNameInfo.status === 'd') {
      _Toast(realNamePendingMsg);

      reject(false);
      return;
    } // 未实名


    if (!userInfo.realNameAuth) {
      _Dialog.confirm(_objectSpread({}, DialogOption)).then(function () {
        // 如果app内打开未实名
        if (appInfo) {
          App.jumpRzPage();
        } else {
          router.push({
            name: 'FYPersonalAuth',
            query: {
              scene: scene
            }
          });
        }
      }).catch(function () {
        reject(false);
      });
    }
  });
}; // 验证钱包状态

export var validWalletStatus = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _ref2, _ref2$status, status, _ref3, _ref3$signingUrl, signingUrl, _yield$store$dispatch, data;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = auth.lsGetFYWalletInfo() || {}, _ref2$status = _ref2.status, status = _ref2$status === void 0 ? null : _ref2$status;
            _ref3 = auth.lsGetFYWalletInfo() || {}, _ref3$signingUrl = _ref3.signingUrl, signingUrl = _ref3$signingUrl === void 0 ? '' : _ref3$signingUrl; // 无钱包状态, 手动获取

            if (!(status === null)) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return store.dispatch('user/GetWalletStatus');

          case 5:
            _yield$store$dispatch = _context.sent;
            data = _yield$store$dispatch.data;
            status = data.status;

          case 8:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              // 钱包开通状态 0-未开通平台钱包未开通富有钱包 1-已开通平台钱包未开通富有钱包 2-富有钱包开通中 3-已开富有钱包 4-富有钱包开通失败 5-已禁用
              if ([0, 1, 2, 4].includes(status)) {
                _Dialog.confirm(_objectSpread({}, walletStatusDialogOption)).then(function () {
                  var routeNameMap = {
                    0: 'FYService',
                    1: 'cashWallet',
                    2: '',
                    4: 'cashWallet'
                  };

                  if (routeNameMap[status]) {
                    router.push({
                      name: routeNameMap[status]
                    });
                  } else if (signingUrl) {
                    // 跳转至签约页
                    // window.open(signingUrl, '_self')
                    initIframeToLink(signingUrl);
                  } else {
                    router.push({
                      name: 'cashWallet'
                    });
                  }
                }).catch(function () {});

                reject(false);
              } else if (status === 5) {
                _Toast(walletDisabledMsg);

                reject(false);
              }

              resolve(true);
            }));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validWalletStatus() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * 权限验证
 * @param scene 场景值,目前只有[登录][实名][钱包][优了个优游戏实名]四种,且为包含关系
 * @param historyRoutePush 微服务提供的跳转方法, 适用于微服务跳转到主应用
 * @returns {Promise<unknown>}
 */

export var hasPermission = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var scene,
        data,
        historyRoutePush,
        isLogin,
        isRealName,
        hasWallet,
        result,
        _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            scene = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 'realName';
            data = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            historyRoutePush = data.historyRoutePush;
            isLogin = false;
            isRealName = false;
            hasWallet = false;

            if (!(scene === 'login')) {
              _context2.next = 10;
              break;
            }

            _context2.next = 9;
            return validLogin(historyRoutePush);

          case 9:
            isLogin = _context2.sent;

          case 10:
            if (!(scene === 'realName')) {
              _context2.next = 18;
              break;
            }

            _context2.next = 13;
            return validLogin(historyRoutePush);

          case 13:
            isLogin = _context2.sent;

            if (!isLogin) {
              _context2.next = 18;
              break;
            }

            _context2.next = 17;
            return validRealName();

          case 17:
            isRealName = _context2.sent;

          case 18:
            if (!(scene === 'realNameEvolution')) {
              _context2.next = 26;
              break;
            }

            _context2.next = 21;
            return validLogin(historyRoutePush);

          case 21:
            isLogin = _context2.sent;

            if (!isLogin) {
              _context2.next = 26;
              break;
            }

            _context2.next = 25;
            return validRealName('evolution');

          case 25:
            isRealName = _context2.sent;

          case 26:
            if (!(scene === 'realNameTPGame')) {
              _context2.next = 35;
              break;
            }

            _context2.next = 29;
            return validLogin(historyRoutePush);

          case 29:
            isLogin = _context2.sent;
            console.log(isLogin);

            if (!isLogin) {
              _context2.next = 35;
              break;
            }

            _context2.next = 34;
            return validRealName('TPGame');

          case 34:
            isRealName = _context2.sent;

          case 35:
            if (!(scene === 'wallet')) {
              _context2.next = 47;
              break;
            }

            _context2.next = 38;
            return validLogin(historyRoutePush);

          case 38:
            isLogin = _context2.sent;

            if (!isLogin) {
              _context2.next = 43;
              break;
            }

            _context2.next = 42;
            return validRealName();

          case 42:
            isRealName = _context2.sent;

          case 43:
            if (!isRealName) {
              _context2.next = 47;
              break;
            }

            _context2.next = 46;
            return validWalletStatus();

          case 46:
            hasWallet = _context2.sent;

          case 47:
            if (!(scene === 'realNameLottie')) {
              _context2.next = 53;
              break;
            }

            isLogin = validLogin(historyRoutePush);

            if (!isLogin) {
              _context2.next = 53;
              break;
            }

            _context2.next = 52;
            return validRealName('Lottie');

          case 52:
            isRealName = _context2.sent;

          case 53:
            if (!(scene === 'realNameExchangeRight')) {
              _context2.next = 59;
              break;
            }

            isLogin = validLogin(historyRoutePush);

            if (!isLogin) {
              _context2.next = 59;
              break;
            }

            _context2.next = 58;
            return validRealName('realNameExchangeRight');

          case 58:
            isRealName = _context2.sent;

          case 59:
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              var isScene = ['realName', 'realNameLottie', 'realNameEvolution', 'realNameExchangeRight', 'realNameTPGame'].includes(scene);

              if (scene === 'login' && isLogin) {
                result = true;
              } else if (isScene && isLogin && isRealName) {
                result = true;
              } else result = scene === 'wallet' && isLogin && isRealName && hasWallet;

              if (result) {
                resolve(true);
              } else {
                reject(false);
              }
            }));

          case 60:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function hasPermission() {
    return _ref4.apply(this, arguments);
  };
}();